export const locale_sv =
    {
        dashboard: 'Hem',
        work_shifts: 'Rapporter',
        projects: 'Alla projekt',
        clients: 'Alla Kunder',
        workers: 'Anställda',
        profile: 'Företagsinställningar',
        areas: 'Arbetsplatser',
        countries: 'Länder',
        cities: 'Städer',
        postal_codes: 'Postnummer',
        my_profile: 'Min profil',
        logout: 'Logga ut',
        pick_a_week: 'Pick a week',
        start_date: 'Start date',
        end_date: 'End date',
        print: 'Print',
        export_excel: 'Export Excel',
        start: 'Start',
        stop: 'Stopp',
        total: 'Total',
        project_name: 'Project Name',
        client: 'Kund',
        worker: 'Anställd',
        project_manager: 'Projektansvarig',
        total_hours: 'Total antal timmar',
        project_description: 'Project beskrivning',
        project_address: 'Project adress',
        planned_start_date: 'Planerat startdatum',
        add_project: 'Skapa ny project',
        update_project: 'Uppdatera project',
        select_client: "Välj kund",
        select_project_manager: 'Välj projektansvarig',
        select_worker: 'Välj anställd',
        select_planned_start_date: 'Välj plannet startdatum',
        address_line1: 'Adress Linje 1',
        address_line2: 'Adress Linje 2',
        select_country: 'Välj land',
        select_city: 'Välj ort',
        select_postal_code: 'Välj Postnummer',
        add_client: 'Skapa ny kund',
        client_address: 'kundadress',
        update_client: 'Uppdatera Kund',
        client_name: 'Kundnamn',
        registered_no: 'Oraganinsationsnummer',
        email: 'Email',
        phone: 'Tel',
        first_name: 'Förnamn',
        client_workers: 'Kundens kontaktperson',
        add_worker: 'Skapa ny anställd',
        update_worker: 'Uppdatera anställd',
        last_name: 'Effternam',
        personal_no: 'Personnummer',
        add_user: 'Skapa ny användare',
        update_user: 'Uppdatera användare',
        login: 'Logga in',
        password: 'Lösenord',
        password_confirmation: 'lösenordsbekräftelse',
        edit_company_profile: 'Ändar förtagsinställningar',
        name: 'Namn',
        submit: 'Spara',
        add_country: 'Skap ny Land',
        update_country: 'Uppdatera land',
        country_name: 'Landsnamn',
        id: 'Nummer',
        add_city: 'Skap nytt ort',
        update_city: 'Uppdatera ort',
        city_name: 'Ortnamn',
        add_postal_code: 'Lägg till postnummer',
        postal_code: 'Postnummer',
        update_postal_code: 'Uppdaterapostnummer',
        postal_code_value: 'Postnummer',
        actions: 'Aktivitet',
        add_work_unit: 'lägg till en arbetspass',
        update_work_unit: 'Uppdatera arbetspass',
        select_project: 'Välj projet',
        select_date: 'Välj datum',
        select_start: 'Välj starttid',
        select_stop: 'Välj sluttid',
        project_managers: 'Projektansvariga',
        address: 'Adress',
        fill_all_required_fields: 'Fyll i alla obligatoriska fält',
        user: 'användare',
        project: 'projekt',
        to_add: 'tillägga',
        to_update: 'att uppdatera',
        change_password: 'Ändra lösenord',
        region: 'Område',
        work_unit: 'arbetspass',
        please_enter_a_valid_address: 'Ange en giltig adress',
        Validate_address: 'Validera adress',
        is_not_valid: 'är inte giltig',
        coordinates: 'Koordinater',
        employment_number: 'Anställningsnummer',
        client_project_number: 'Kundens projektnummer',
        own_project_number: 'Eget projektnummer',
        is_not_unique: 'är inte unik',
        status: 'Status',
        company: 'Företag',
        date: 'Datum',
        i_dont_remember_my_login: 'Jag kommer inte ihåg min inloggning',
        get_back: 'Kom tillbaka',
        check_spam: 'Om du inte har fått något e-postmeddelande, kontrollera din skräppostmapp',
        password_changed: 'lösenordet har ändrats',
        check_email: 'Kolla gärna din e-post',
        daily_report: 'Daglig rapport',
        send:'Skicka',
        description: 'Beskrivning',
        access_groups: 'Åtkomstgrupp',
        companies: "Företag",
        add_company: "Lägg till företag",
        company_name: "Företagsnamn",
        registered_num: "Registrerat nummer",
        company_address: "Företags Adress",
        website: "Hemsida",
        update_company: "Uppdatera företaget",
        Address:"Adress",
        Role:"Roll",
        First_Name:"Förnamn",
        Second_Name:"Andranamn",
        Org_nummer: "Org. nummer",
        Calendar:'Kalender',
        Weekends: 'Helger',
        Days_off: 'Lediga dagar',
        Timesheet: 'Tidrapport',
        Days_of_the_week: ['Mån', 'Tis', 'Ons', 'Tors', 'Fre', 'Lör', 'Sön'],
        Report_date: 'Rapportdatum',
        Sample_period: 'Provperiod',
        Worker_report : 'Arbetarrapport',
        Project_report: "Projektets rapport",
        Client_report: "Kundens rapport"
    };